/**
 * Utilidad para generar código de barras propio.
 * Si hay código de proveedor válido: marca (3 chars) + código proveedor + tamaño.
 * Si no hay código de proveedor: marca (3) + modelo (3) + tamaño, para que siempre se muestre algo en Autogenerar.
 *
 * @param {string|{nombre:string}} marca - Nombre de marca (string o objeto con .nombre)
 * @param {string|{tamanio:string}} tamanio - Tamaño (string o objeto con .tamanio)
 * @param {string} codigoBarrasProveedor - Código del proveedor (opcional)
 * @param {string} [modelo] - Modelo (opcional, usado cuando no hay código proveedor)
 * @returns {string}
 */
export function normalizarCodigoBarras(val) {
  return (val || "").trim().replace(/\s+/g, " ");
}

function abreviar(str, maxLen = 3) {
  const s = String(str || "").trim().replace(/\s/g, "");
  return s.substring(0, maxLen).toUpperCase();
}

export function generarCodigoBarrasPropio(marca, tamanio, codigoBarrasProveedor, modelo) {
  const marcaNombre = typeof marca === "object" && marca ? (marca.nombre || "") : String(marca || "");
  const marcaAbreviada = abreviar(marcaNombre, 3);
  const tamanioVal =
    typeof tamanio === "object" && tamanio && tamanio.tamanio != null
      ? String(tamanio.tamanio).trim()
      : String(tamanio || "").trim();
  const modeloVal = String(modelo || "").trim();

  const codigoProv = normalizarCodigoBarras(codigoBarrasProveedor);
  const tieneCodigoProveedor = codigoProv && !codigoProv.includes(",");

  if (tieneCodigoProveedor) {
    const codigo = codigoProv.length > 15 ? codigoProv.substring(0, 15) : codigoProv;
    return `${marcaAbreviada} ${codigo.toUpperCase()} ${tamanioVal}`.trim();
  }

  if (marcaAbreviada || modeloVal || tamanioVal) {
    const modeloAbr = abreviar(modeloVal, 3);
    const parts = [marcaAbreviada, modeloAbr, tamanioVal].filter(Boolean);
    if (parts.length === 1 && modeloVal) return abreviar(modeloVal, 10);
    return parts.join("-") || "";
  }

  return "";
}

export const OPCIONES_MODO_CODIGO_BARRAS = [
  { text: "Autogenerar (marca + modelo + tamaño)", value: "autogenerar" },
  { text: "Usar el mismo que el código del proveedor", value: "usarProveedor" },
  { text: "Escribir manualmente", value: "manual" },
];
